import React, { useContext } from 'react';

import { CompanyContext } from '../../../../../../context/company/companyContext';
import { formatDateForDisplay } from '../../../../../../utils/datetime/datetime';

interface IFormattedDateRangeProps {
  startDate: string;
  endDate: string;
  separator?: '/' | '-';
}

const FormattedDateRange: React.FC<IFormattedDateRangeProps> = ({ startDate, endDate, separator }) => {
  const { isUSA } = useContext(CompanyContext);
  const formattedStart = formatDateForDisplay(startDate, isUSA ?? false, separator);
  const formattedEnd = formatDateForDisplay(endDate, isUSA ?? false, separator);
  return <div>{`${formattedStart} - ${formattedEnd}`}</div>;
};

export default FormattedDateRange;
